import { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import { selectAtom } from 'jotai/utils'

import { authCityAtom } from '../atoms/auth-city.atom'

export const useAuthCityValue = () => {
    const selectedCity = useAtomValue(useMemo(() => selectAtom(authCityAtom, (state) => state), []))

    return {
        selectedCity,
    }
}
